import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister';
import type { PersistQueryClientOptions } from '@tanstack/react-query-persist-client';
import { del, get, set } from 'idb-keyval';

// Bump when persisted query shapes change incompatibly.
const CACHE_BUSTER = 'fdtr-v1';

const persister = createAsyncStoragePersister({
  storage: {
    getItem: (key: string) => get<string>(key).then((v) => v ?? null),
    setItem: (key: string, value: string) => set(key, value),
    removeItem: (key: string) => del(key),
  },
  key: 'wb-query-cache',
  throttleTime: 2_000,
});

// Never persisted: freshness must fetch live for the staleness detector; plans
// and trades are user-mutable RDS state with staleTime Infinity.
const LIVE_ONLY = new Set(['freshness', 'plans', 'recorded-trades']);

/** Instant-paint restore of the FDTR feeds. */
export const persistOptions: Omit<PersistQueryClientOptions, 'queryClient'> = {
  persister,
  maxAge: 24 * 60 * 60 * 1000,
  buster: CACHE_BUSTER,
  dehydrateOptions: {
    shouldDehydrateQuery: (q) =>
      q.state.status === 'success' &&
      q.queryKey[0] === 'fdtr' &&
      !LIVE_ONLY.has(String(q.queryKey[1])),
  },
};
